import { render, staticRenderFns } from "./loader-inline.vue?vue&type=template&id=2ec98224"
import script from "./loader-inline.vue?vue&type=script&lang=js"
export * from "./loader-inline.vue?vue&type=script&lang=js"
import style0 from "./loader-inline.vue?vue&type=style&index=0&id=2ec98224&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports